/**
 * https://gist.github.com/auser/1d55aa3897f15d17caf21dc39b85b663#file-googleapi-js-L1-Lundefined
 */

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';

import cache from '../utils/ScriptCache';
import GoogleApi from '../utils/GoogleApi';

const defaultMapConfig = {}
export const wrapper = (options) => (WrappedComponent) => {
  const apiKey = options.apiKey;
  const libraries = options.libraries || ['places'];
  const version = options.version;
  const url = options.url;

  class Wrapper extends React.Component {
    constructor(props, context) {
      super(props, context);

      this.state = {
        loaded: false,
        google: null
      }
    }

    componentDidMount() {
      this.scriptCache.google.onLoad((err, tag) => {
        const props = _.assign({}, this.props, {
          loaded: this.state.loaded
        });

        this.setState({
          loaded: true,
          google: window.google
        });
      });
    }

    componentWillMount() {
      this.scriptCache = cache({
        google: GoogleApi({
          apiKey: apiKey,
          libraries: libraries,
          version,
          url
        })
      });
    }

    render() {
      const props = _.assign({}, this.props, {
        loaded: this.state.loaded,
        google: this.state.google
      });

      return (
        <div>
          <WrappedComponent
            {...props}
          />
        </div>
      )
    }
  }

  return Wrapper;
}

export default wrapper;
